import _ from 'lodash';
import AudienceSubcategory from './AudienceSubcategory';
export default class AudienceCategory extends Object {

    constructor(category) {
        super();
        _(this).keys().each(key => {
            if (category.hasOwnProperty(key)) {
                this[key] = category[key];
            }
        });
        this.subcategories = _.map(category.subcategories, subcategory => new AudienceSubcategory(subcategory));
    }

    category = null;
    category_key = null;
    subcategories = [];

    updateSubcategoriesSelectedAttributes(selectedAttributes) {
        _.each(this.subcategories, subcategory => subcategory.updateItemsSelectedAttributes(selectedAttributes));
    }

    calculateSelectedRequirements() {
        const requirements = _.flatMap(this.subcategories, subcategory => subcategory.items);

        return _.sumBy(requirements, requirement => requirement.hasAttributesToRemove() ? 1 : 0);
    }
}

